// Johns Hopkins' undergraduate majors (#2652, batch 2). Read on 2026-10-01
// from the official e-Catalogue's Programs page (e-catalogue.jhu.edu/
// programs/), filtered to Bachelor's: the full-time Krieger and Whiting
// programs and the Peabody Institute's degrees. Left out: minors,
// certificates, combined BA/MA and BS/MS programs, the five-year Peabody
// programs, the Peabody-Homewood double degree and the SAIS direct
// matriculation program (none is a separate first-year major). A major
// listed with both a BA and a BS appears once with both degrees. Peabody's
// 'Bachelor of Music in X' entries are listed as X, degree BM. The KB's
// majors list was the starting point; the catalogue wins.
const majors = {
    "slug": "johns-hopkins-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's program in the official Johns Hopkins e-Catalogue for the undergraduate schools that admit first-year students, grouped by school, with the degree it leads to. Minors, certificates and combined bachelor's and master's programs are left out.",
    "groups": [
        {
            "name": "Krieger School of Arts and Sciences",
            "source": {
                "label": "Johns Hopkins e-Catalogue, Programs (Bachelor's)",
                "url": "https://e-catalogue.jhu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Archaeology",
                    "degree": "BA"
                },
                {
                    "name": "Behavioral Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biophysics",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "Cognitive Science",
                    "degree": "BA"
                },
                {
                    "name": "Critical Diaspora Studies",
                    "degree": "BA"
                },
                {
                    "name": "Earth and Planetary Sciences",
                    "degree": "BA"
                },
                {
                    "name": "East Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "Film and Media Studies",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "History of Art",
                    "degree": "BA"
                },
                {
                    "name": "History of Science, Medicine, and Technology",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BA"
                },
                {
                    "name": "International Studies",
                    "degree": "BA"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Latin American, Caribbean, and Latinx Studies",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Medicine, Science, and the Humanities",
                    "degree": "BA"
                },
                {
                    "name": "Molecular and Cellular Biology",
                    "degree": "BS"
                },
                {
                    "name": "Moral and Political Economy",
                    "degree": "BA"
                },
                {
                    "name": "Natural Sciences Area",
                    "degree": "BA"
                },
                {
                    "name": "Near Eastern Studies",
                    "degree": "BA"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA or BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Public Health Studies",
                    "degree": "BA"
                },
                {
                    "name": "Romance Languages",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Writing Seminars",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Whiting School of Engineering",
            "source": {
                "label": "Johns Hopkins e-Catalogue, Programs (Bachelor's)",
                "url": "https://e-catalogue.jhu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Applied Mathematics and Statistics",
                    "degree": "BA or BS"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical and Biomolecular Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA or BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Mechanics",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "General Engineering",
                    "degree": "BA"
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Systems Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Peabody Institute",
            "source": {
                "label": "Johns Hopkins e-Catalogue, Programs (Bachelor's)",
                "url": "https://e-catalogue.jhu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Dance",
                    "degree": "BFA"
                },
                {
                    "name": "Composition",
                    "degree": "BM"
                },
                {
                    "name": "Hip Hop",
                    "degree": "BM"
                },
                {
                    "name": "Jazz Performance",
                    "degree": "BM"
                },
                {
                    "name": "Music Education",
                    "degree": "BM"
                },
                {
                    "name": "Music for New Media",
                    "degree": "BM"
                },
                {
                    "name": "Performance",
                    "degree": "BM"
                },
                {
                    "name": "Performance - Computer Music",
                    "degree": "BM"
                },
                {
                    "name": "Performance - Guitar",
                    "degree": "BM"
                },
                {
                    "name": "Performance - Harpsichord",
                    "degree": "BM"
                },
                {
                    "name": "Performance - Historical Performance",
                    "degree": "BM"
                },
                {
                    "name": "Performance - Orchestral Instruments",
                    "degree": "BM"
                },
                {
                    "name": "Performance - Organ",
                    "degree": "BM"
                },
                {
                    "name": "Performance - Piano",
                    "degree": "BM"
                },
                {
                    "name": "Performance - Voice",
                    "degree": "BM"
                },
                {
                    "name": "Recording Arts & Sciences",
                    "degree": "BM"
                }
            ],
            "note": "Peabody sets its own application requirements and deadlines, published on peabody.jhu.edu.",
            "noteSource": "deadlines"
        }
    ]
};

export default majors;
